import { categoryActionsTypes } from '../../types/category';
import { userTypes } from '../../types/user';

const INITIAL_STATE = {
  loading: false,
  categories: null,
  error: {},
  productCosts: {} as { [key: number]: number },
};

const categoryReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case categoryActionsTypes.GET_CATEGORY_ITMES_REQUEST:
      return { ...state, loading: true, categories: null, error: {} };
    case categoryActionsTypes.GET_CATEGORY_ITMES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
        error: {},
      };
    case categoryActionsTypes.GET_CATEGORY_ITMES_FAILURE:
      return { ...state, loading: false, error: action.error };
    case categoryActionsTypes.SET_PRODUCT_COST:
      return {
        ...state,
        productCosts: {
          ...state.productCosts,
          [action.payload.productId]: action.payload.minCost,
        },
      };
    case userTypes.USER_LOGOUT: 
      return {
        ...INITIAL_STATE
      }   
    default:
      return state;
  }
};

export default categoryReducer;
